import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DD31FFF2-A93B-41F5-BA6C-1732E8A8DEFF
 * name timer-sand-empty
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-empty.svg
 * tags
 * - Date / Time 
 */
export const TimerSandEmptyIcon = createSvgIcon(<><path d="M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6M16,16.5V20H8V16.5L12,12.5L16,16.5M12,11.5L8,7.5V4H16V7.5L12,11.5Z" /></>, 'TimerSandEmptyIcon');
export default TimerSandEmptyIcon